import {Component, inject} from '@angular/core';
import {Breadcrumb} from 'primeng/breadcrumb';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {BreadcrumbService} from '../../../services/breadcrumb.service';

@Component({
  selector: 'component-breadcrumb',
  imports: [
    Breadcrumb,
    TranslatePipe
  ],
  templateUrl: './component-breadcrumb.component.html',
  styleUrl: './component-breadcrumb.component.scss'
})
export class ComponentBreadcrumb {

  router: Router = inject(Router);
  breadcrumbService: BreadcrumbService = inject(BreadcrumbService);

  goTo(page: string[]): void {
    this.router.navigate(page);
  }

}
